/*!
 * jQuery UI Unique ID 1.14.1
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */ //>>label: uniqueId
//>>group: Core
//>>description: Functions to generate and remove uniqueId's
//>>docs: https://api.jqueryui.com/uniqueId/
(function(factory) {
    "use strict";
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define([
        "jquery",
        "./version"
    ], factory);
    else // Browser globals
    factory(jQuery);
})(function($) {
    "use strict";
    return $.fn.extend({
        uniqueId: function() {
            var uuid = 0;
            return function() {
                return this.each(function() {
                    if (!this.id) this.id = "ui-id-" + ++uuid;
                });
            };
        }(),
        removeUniqueId: function() {
            return this.each(function() {
                if (/^ui-id-\d+$/.test(this.id)) $(this).removeAttr("id");
            });
        }
    });
});

//# sourceMappingURL=index.1724c98b.js.map
